<template>
  <el-dialog :visible.sync="dialogFormVisible" :title="titles[updateType]" :before-close="close">
    <el-form ref="form" label-width="120px" :model="initForm" :rules="rules">
      <el-form-item label="设备MAC地址" prop="mac">
        <el-input v-model="initForm.mac" placeholder="请输入设备MAC地址"></el-input>
      </el-form-item>

      <el-form-item label="云平台" prop="cloud">
        <el-select v-model="initForm.cloud" placeholder="请选择云平台">
        <el-option
          v-for="cloud in cloudEnvList"
          :label="cloud"
          :key="cloud"
          :value="cloud"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="动作类型" prop="action">
        <el-select multiple v-model="initForm.action" placeholder="请选择动作类型（多选）">
        <el-option
          v-for="action in deviceActionTypes"
          :label="action.name"
          :key="action.value"
          :value="action.value"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="动作开关" prop="switch">
        <el-select v-model="initForm.switch" placeholder="开启或关闭动作监控">
        <el-option
          v-for="status in switchStatus"
          :label="status"
          :key="status"
          :value="status"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="days" label="监控天数">
        <el-input v-model="initForm.days" placeholder="请输入监控天数"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onSubmit">提交</el-button>
      <el-button @click="$emit('close')" type="info">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { SwitchStatus, DeviceActionTypes } from "@/components/Index/data.js";

export default {
  props: {
    initForm: {},
    updateType: {},
    cloudEnvList: {}
  },
  data() {
    return {
      dialogFormVisible: true,
      rules: {
        mac: [{required: true, message: "请输入设备MAC地址", trigger: "blur"}],
        cloud: [{required: true, message: "请选择云平台", trigger: "blur"}],
        action: [{required: true, message: "请选择动作类型", trigger: "blur"}],
        days: [{required: true, message: "请输入监控天数", trigger: "blur"}]
      },
      titles: {
        add: "新增",
        edit: "编辑"
      },
      deviceActionTypes: DeviceActionTypes,
      switchStatus: SwitchStatus
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        var method = "";
        var url = "";
        var msg = "操作失败";
        var formData = {
              mac: this.initForm.mac,
              cloud: this.initForm.cloud,
              action: this.initForm.action.reduce((a, b) => a | b, 0),
              switch: +(this.initForm.switch === '开启'),
              days: this.initForm.days,
            };
        if (!valid) {alert("请检查输入是否正确！"); return false;};
        this.dialogFormVisible = false;
        if (this.updateType === "add") {
          method = "post";
          url = "device-action/info/";
          msg = "添加成功";
        } else if (this.updateType === "edit") {
          method = "post";
          url = "device-action/info/" + this.initForm.id + "/";
          msg = "编辑成功";
        } else{
          return false;
        };
        this.$http[method](
          url,
          formData,
          () => {
            this.$baseNotice.message(msg);
            this.$emit("close");
            this.$emit("update");
          }
        )
      });
    }
  }
};
</script>
